<template>
  <div>
    <div class="row-container">
      <div class="field-container">
        <label for="" class="field-label">Land:</label>
        <multiselect @input="refresh()" v-model="selectedCountry" :options="countries" multiple="true"  placeholder="Selecteer een land" selected-label="✔" select-label="" deselect-label="✔" style="margin-right: 10px" />
      </div>
      <div class="field-container">
        <label for="" class="field-label">Verkoopkanaal:</label>
        <multiselect @input="refresh()" v-model="selectedSalesChannel" :options="marketplaces" multiple="true" placeholder="Selecteer een marktplaats" selected-label="✔" select-label="" deselect-label="✔" style="margin-right: 10px" />
      </div>
      <div class="field-container">
        <label for="" class="field-label">Periode van</label>
         <input class="field-select form-control" @change="refresh()" type="date" placeholder="Periode van" v-model="selectedPeriodFrom" style="height: 40px; margin-right: 10px">
      </div>
      <div class="field-container">
        <label for="" class="field-label">Periode tot:</label>
          <input class="field-select form-control" @change="refresh()" type="date" placeholder="Periode van" v-model="selectedPeriodTo" style="height: 40px; margin-right: 10px">
      </div>
    </div>
    <api-table-block ref="ordersTable" :fields="fields" :items="findAllOrders" default-sort-by="profit" item-label-singular="bestelling" item-label-plural="bestellingen">
      <template slot="order_number" slot-scope="data">
        <a href="#" @click.prevent="openDetailModal(data.item.orders_id)">#{{data.value}}</a>
      </template>
      <template slot="total_sale_price" slot-scope="data">
        {{parseFloat(data.value) | money}}
      </template>
      <template slot="purchase_price" slot-scope="data">
        {{ parseFloat(data.value)  | money}}
      </template>
      <template slot="sales_channel_commision" slot-scope="data">
        {{ parseFloat(data.value)  | money}}
      </template>
      <template slot="shipping_cost" slot-scope="data">
        {{ parseFloat(data.value)  | money}}
      </template>
      <template slot="profit" slot-scope="data">
        {{ parseFloat(data.value) | money}}
      </template>
      <template slot="profit_percentage" slot-scope="data">
        <b v-if="data.value >= 30" class="text-success">{{data.value + '%'}}</b>
        <b v-if="data.value < 30 && data.value >= 0" class="text-warning">{{data.value + '%'}}</b>
        <b v-if="data.value < 0" class="text-danger">{{data.value + '%'}}</b>
      </template>
    </api-table-block>

    <div class="block block-bordered">
      <div class="block-header block-header-default">
        <h3 class="block-title">Kosten</h3>
      </div>
      <div class="bg-light rounded d-flex flex-column">
          <div class="p-2 d-flex">
              <div class="col-8">Totale inkoopkosten: </div>
              <div class="ml-auto">€ {{ total_purchase_price }}</div>
          </div>
          <div class="p-2 d-flex">
              <div class="col-8">Totale commissiekosten</div>
              <div class="ml-auto">€ {{ total_commission }}</div>
          </div>
          <div class="p-2 d-flex">
              <div class="col-8">Totale verzendkosten</div>
              <div class="ml-auto">€ {{ total_shipping_cost }}</div>
          </div>
          <div class="border-top px-4 mx-3"></div>
          <div class="p-2 d-flex pt-3">
              <div class="col-8"><b>Totale kosten</b></div>
              <div class="ml-auto"><b class="green">€ {{total_costs}}</b></div>
          </div>
      </div>
    </div>

    <div class="block block-bordered">
      <div class="block-header block-header-default">
        <h3 class="block-title">Opbrengsten</h3>
      </div>
      <div class="bg-light rounded d-flex flex-column">
          <div class="p-2 d-flex">
              <div class="col-8">Totale omzet: </div>
              <div class="ml-auto">€ {{ total_revenue }}</div>
          </div>
          <div class="p-2 d-flex">
              <div class="col-8">Gemiddelde winstpercentage</div>
              <div class="ml-auto">{{ parseFloat(average_profit_percentage).toFixed(2)}}%</div>
          </div>
          <div class="border-top px-4 mx-3"></div>
          <div class="p-2 d-flex pt-3">
              <div class="col-8"><b>Totale winst</b></div>
              <div class="ml-auto"><b class="green">€ {{total_profit}}</b></div>
          </div>
      </div>
    </div>
    
     <order-detail-modal v-if="detailModalOrderId" :key="detailModalOrderId" :order-id="detailModalOrderId" @close="detailModalOrderId = null"></order-detail-modal>
  </div>
</template>

<script>
import http from '../utils/http'
import ApiTableBlock from '../common/ApiTableBlock'
import OrderDetailModal from '../orders/OrderDetailModal'
export default {
  components: {
    ApiTableBlock,
    OrderDetailModal
  },
  data () {
    return {
      fields: {
        order_number: {
          label: 'Bestelling',
          sortable: true,
          thStyle: 'width: 20%;'
        },
        total_sale_price: {
          label: 'Totaalbedrag',
          sortable: true,
          thStyle: 'width: 20%;'
        },
        purchase_price: {
          label: 'Inkoopwaarde',
          sortable: true,
          thStyle: 'width: 20%;'
        },
        sales_channel_commision: {
          label: 'Commisie',
          sortable: true,
          thStyle: 'width: 20%;'
        },
        shipping_cost: {
          label: 'Verzend kosten',
          thStyle: 'width: 20%;'
        },
        profit: {
          label: 'Winstbedrag',
          sortable: true,
          thStyle: 'width: 20%;'
        },
        profit_percentage: {
          label: 'Winstpercentage',
          sortable: true,
          thStyle: 'width: 20%;'
        }
      },
      detailModalOrderId: null,
      orderReportTotals: [],
      countries: [],
      marketplaces: [],
      selectedCountry: null,
      selectedSalesChannel: null,
      selectedPeriodFrom: null,
      selectedPeriodTo: null,

      total_purchase_price: 0,
      total_commission: 0,
      total_shipping_cost: 0,
      totaL_costs: 0,

      total_revenue: 0,
      average_profit_percentage: 0,
      total_profit: 0

    }
  },
  computed: {
    ordersTable () {
      return this.$refs.ordersTable
    }
  },
  methods: {
    findAllOrders (params) {
      if (this.selectedCountry) {
        params['filter[order.billing_country]'] = this.selectedCountry
      }

      if (this.selectedSalesChannel) {
        params['filter[specific_orders]'] = this.selectedSalesChannel
      }

      if (this.selectedPeriodFrom) {
        params['filter[period_from]'] = this.selectedPeriodFrom
      }

      if (this.selectedPeriodTo) {
        params['filter[period_to]'] = this.selectedPeriodTo
      }

      this.$api.getOrderReportTotals(params)
        .then((result) => {
          this.orderReportTotals = result.data.data
          this.total_purchase_price = this.orderReportTotals[0].total_purchase_price
          this.total_commission = this.orderReportTotals[0].total_commission
          this.total_shipping_cost = this.orderReportTotals[0].total_shipping_cost
          this.total_costs = this.orderReportTotals[0].total_costs

          this.total_revenue = this.orderReportTotals[0].total_revenue
          this.average_profit_percentage = this.orderReportTotals[0].average_profit_percentage
          this.total_profit = this.orderReportTotals[0].total_profit
        })
        .catch(() => {
          this.$swal('Ehmm...', 'Deze bestelling konden we niet vinden. Probeer het opnieuw.', 'warning')
        })

      return this.$api.getOrderReport(params)
    },
    refresh () {
      this.ordersTable.refresh()
    },
    openDetailModal (orderId) {
      this.detailModalOrderId = orderId
    },
    loadContries () {
      http.get('order-countries')
      .then((result) => {
        this.countries = result.data.data
      })
    },
    loadMarketplaces () {
      http.get('order-marketplaces')
      .then((result) => {
        this.marketplaces = result.data.data
      })
    }
  },
  created () {
    this.loadContries()
    this.loadMarketplaces()
  }

}
</script>
<style scoped>
.row-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 2em;
  padding-bottom: 15px;
}

.field-container {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}

.badge {
  float:right;
  padding-left: 9px;
  padding-right: 9px;
  -webkit-border-radius: 9px;
  -moz-border-radius: 9px;
  border-radius: 9px;
}

.label-warning[href],
.badge-warning[href] {
  background-color: #c67605;
}
#lblCartCount {
    font-size: 12px;
    background: #ff0000;
    color: #fff;
    padding: 5 5px;
    vertical-align: top;
}
</style>


// WEBPACK FOOTER //
// PurchasingValuesOrdersPage.vue?4bd9689d